import { AccountRepresentativeContactCard } from "./AccountRepresentativeContactCard";
import { WOUND_CARE_ORDER_FORM_URL } from "../constants";
import { getLocalizedHoursString } from "./ContactUs";

const ContactUsGetInTouch = () => {
  return (
    <div className="tw-mx-auto tw-mt-[30px] tw-flex tw-max-w-[calc(100vw-15%)] tw-flex-row tw-flex-wrap">
      <div className="tw-w-1/2 tw-p-[13px] tw-px-[20px] tw-text-blue-dark-1 840:tw-w-full">
        <h1 className="tw-text-[48px]">Get in touch.</h1>
        <p className="tw-mt-[3px]">
          We're excited to work with you in our pursuit to provide a seamless
          and reliable in-home care experience for clinicians and patients.
        </p>
        <AccountRepresentativeContactCard />
      </div>
      <div className="tw-w-1/2 tw-px-[20px] tw-pb-[20px] tw-pt-[13px] tw-text-blue-dark-1 840:tw-w-full">
        <div className="tw-my-[10px] tw-flex tw-flex-row">
          <div className="tw-pt-[20px] tw-text-[24px]">
            <i className="fa fa-phone" />
          </div>
          <div className="tw-px-[15px] tw-text-[16px] tw-text-gray-2">
            <h3>Phone</h3>
            <p>
              If you'd like to talk, just give us a call. You'll always talk to
              a real person, no robots.
            </p>
            <p>
              <b>Our Phone Number:</b>{" "}
              <a
                className="tw-text-blue-1 tw-underline hover:tw-text-blue-dark-1"
                href="tel:1-833-518-1613"
              >
                (833) 518 - 1613
              </a>
              <br />
              <b>Hours of operation:</b> {getLocalizedHoursString(9)}, Monday -
              Friday
            </p>
          </div>
        </div>
        <div className="tw-my-[10px] tw-flex tw-flex-row">
          <div className="tw-pt-[20px] tw-text-[24px]">
            <i className="fa fa-fax" />
          </div>
          <div className="tw-px-[15px] tw-text-[16px] tw-text-gray-2">
            <h3>Fax</h3>
            <p>
              Are you a provider sending orders on behalf of your patients? You
              can send a fax order to us.
            </p>
            <p>
              <b>Our Fax Number:</b> (833) 694 - 1477
              <br />
              <b>Our Fax Number for Progress Notes:</b> (833) 672 - 2753
              <br />
              <b>Order Form:</b>{" "}
              <a
                className="tw-text-blue-1 tw-underline hover:tw-text-blue-dark-1"
                href={WOUND_CARE_ORDER_FORM_URL}
              >
                Download here
              </a>
            </p>
          </div>
        </div>
        <div className="tw-my-[10px] tw-flex tw-flex-row">
          <div className="tw-pt-[20px] tw-text-[24px]">
            <i className="fa fa-envelope" />
          </div>
          <div className="tw-px-[15px] tw-text-[16px] tw-text-gray-2">
            <h3>Email</h3>
            <p>
              You can reach us through email as well. One of our team members
              will get back to you over email soon.
            </p>
            <p>
              <b>Provider Emails:</b>{" "}
              <a
                className="tw-text-blue-1 tw-underline hover:tw-text-blue-dark-1"
                href={"mailto:provider-support@versemedical.com"}
              >
                provider-support@versemedical.com
              </a>
              <br />
              <b>Patient Emails:</b>{" "}
              <a
                className="tw-text-blue-1 tw-underline hover:tw-text-blue-dark-1"
                href={"mailto:patient-support@versemedical.com"}
              >
                patient-support@versemedical.com
              </a>
              <br />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsGetInTouch;
